import { linkGeneric } from '../../../utils/shiftnative/utils';
import groupingLinkTypeSelectors from '../../../utils/shiftnative/subaruLinkTypeSelectors';
import groupingLocationSelectors from '../../../utils/shiftnative/subaruLocationSelectors';

export default {
	events: {
		'ddc.link.generic': [
			{
				logic: ({ eventData }) =>
					eventData?.attributes?.class?.includes?.(
						'WISE-love-promise-learn-more-btn'
					),
				payload: () => ({
					data: {
						events: 'linkClick',
						linkType: 'Love Promise Event'
					}
				})
			},
			{
				payload: ({ element, eventData, mapping }) => {
					return linkGeneric({
						element,
						eventData,
						groupingLinkTypeSelectors,
						groupingLocationSelectors,
						mapping
					});
				}
			}
		]
	}
};
